import DeliverooFull from 'marketing-website/components/icons/DeliverooFull';
import heroImage from 'marketing-website/media/images/pages/case-studies/deliveroo/cover@2x.jpg';
import statsImage from 'marketing-website/media/images/pages/case-studies/deliveroo/stats@2x.jpg';
import image01a from 'marketing-website/media/images/pages/case-studies/deliveroo/image-01-a@2x.jpg';
import image01b from 'marketing-website/media/images/pages/case-studies/deliveroo/image-01-b@2x.jpg';
import image02a from 'marketing-website/media/images/pages/case-studies/deliveroo/image-02-a@2x.jpg';
import image02b from 'marketing-website/media/images/pages/case-studies/deliveroo/image-02-b@2x.jpg';
import image03a from 'marketing-website/media/images/pages/case-studies/deliveroo/image-03-a@2x.jpg';
import image03b from 'marketing-website/media/images/pages/case-studies/deliveroo/image-03-b@2x.jpg';
import image04a from 'marketing-website/media/images/pages/case-studies/deliveroo/image-04-a@2x.jpg';
import image04b from 'marketing-website/media/images/pages/case-studies/deliveroo/image-04-b@2x.jpg';
import imageQuote from 'marketing-website/media/images/pages/case-studies/deliveroo/image-quote@2x.jpg';

const deliverooAssets = {
  heroImage: {
    src: heroImage,
    srcSet: heroImage,
    alt: '',
    maxWidth: 504,
  },
  heroLogo: DeliverooFull,
  statsImage: {
    alt: '',
    maxWidth: 1290,
    src: statsImage,
  },
  stats: [
    {
      id: 0,
      stat: '2+',
      title: 'Years as a Marvel customer',
      copy:
        'Deliveroo have been prototyping and scaling at pace with Marvel since November 2015',
    },
    {
      id: 1,
      stat: '20',
      title: 'Designers using Marvel',
      copy:
        'Their team of 20 designers use Marvel to share designs, prototypes and iterate fast.',
    },
    {
      id: 2,
      stat: '15',
      title: 'Research & content users',
      copy: `Marvel isn't restricted to designers at Deliveroo, it fits with their collaborative culture`,
    },
  ],
  doubleImages: {
    first: [
      {
        src: image01a,
        maxWidth: 536,
        alt: '',
      },
      {
        src: image01b,
        maxWidth: 551,
        alt: '',
      },
    ],
    second: [
      {
        src: image02a,
        maxWidth: 460,
        alt: '',
      },
      {
        src: image02b,
        maxWidth: 460,
        alt: '',
      },
    ],
    third: [
      {
        src: image03a,
        maxWidth: 536,
        alt: '',
      },
      {
        src: image03b,
        maxWidth: 550,
        alt: '',
      },
    ],
    fourth: [
      {
        src: imageQuote,
        maxWidth: 556,
        alt: '',
      },
      {
        maxWidth: 440,
        copy:
          '"We use Marvel a lot for user testing. Actually being able to create a scenario, prepare a flow for a person and have them walk through it step-by-step creates such valuable feedback."',
      },
    ],
    fifth: [
      {
        src: image04a,
        maxWidth: 556,
        alt: '',
      },
      {
        src: image04b,
        maxWidth: 556,
        alt: '',
      },
    ],
  },
};

export default deliverooAssets;



// WEBPACK FOOTER //
// ./src/configs/caseStudies/deliveroo.js